import axios from "axios";

export default axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_VITE_EXTERNALS_LAB_API_URL}`,
  headers: { "Content-Type": "application/json" },
});
